import {
  initiateProjectAutomatedScoping, initiateWebProjectEstimation,
} from '@/services/repository';
import { testBoxTypes } from '@/constants/projects';
import store from '@/store';

export async function estimateWebProject(projectOptions, resourcesData) {
  const { testingType, bundle } = projectOptions;

  const testingTypeMap = {
    [testBoxTypes.BLACK_BOX]: 'black',
    [testBoxTypes.GRAY_BOX]: 'grey',
  };

  const payload = {};

  resourcesData.forEach(resource => {
    payload[resource.value] = {
      type: 'applicative',
      platform: 'web',
      box: testingTypeMap[testingType],
      bundle,
      location: 'remote',
      retest: false,
      usrRolesAmnt: 1,
      api: 1,
    };

    resource.features.forEach(feature => {
      payload[resource.value][feature.value] = feature.selected;
    });
  });

  const estimationData = await initiateWebProjectEstimation(payload);

  // Estimation in hours
  return Math.round(
    // eslint-disable-next-line camelcase
    resourcesData.reduce((summ, { value }) => summ + Number(estimationData[value]?.Project_Hours || 0), 0),
  );
}

export async function runAutomatedScoping(resources, projectPayload, projectNavigationPayload) {
  const payload = {
    domain: store.getters.domains[0] || '',
    targets: [],
    projectPayload,
    projectNavigationPayload,
  };
  resources.forEach(resource => {
    payload.targets.push({
      tld: resource.value,
      credentials: (resource.credentials || []).filter(({ username }) => username),
    });
  });
  const response = await initiateProjectAutomatedScoping(payload);
  return response;
}
